import React, { useEffect, useRef } from "react";
import ReactDOM from "react-dom";
import Button from "./Button";
import "./ConfirmModal.css";

const ConfirmModal = ({
    title,
    message,
    confirmLabel = "Confirm",
    cancelLabel = "Cancel",
    variant = "danger",
    onConfirm,
    onCancel,
}) => {
    const cancelRef = useRef(null);

    useEffect(() => {
        cancelRef.current?.focus();
    }, []);

    useEffect(() => { 
        const onKey = (e) => {
            if (e.key === "Escape") onCancel();
        };
        document.addEventListener("keydown", onKey);
        return () => document.removeEventListener("keydown", onKey);
    }, [onCancel]); 

    return ReactDOM.createPortal(
        <div className="tw-modal-overlay ui-confirm-overlay" onClick={onCancel}>
            <div
                className="tw-modal ui-confirm"
                onClick={(e) => e.stopPropagation()}
                role="dialog"
                aria-modal="true"
                aria-labelledby="ui-confirm-title"
            >
                <div className="tw-modal__header">
                    <h3 className="tw-modal__title" id="ui-confirm-title">{title}</h3>
                </div>
                <div className="ui-confirm__body">
                    {typeof message === "string" ? (
                        <p className="ui-confirm__message">{message}</p>
                    ) : (
                        message
                    )}
                    <div className="ui-confirm__actions">
                        <Button
                            ref={cancelRef}
                            variant="secondary"
                            size="sm"
                            onClick={onCancel}
                        >
                            {cancelLabel}
                        </Button>
                        <Button
                            variant={variant}
                            size="sm"
                            onClick={onConfirm}
                        >
                            {confirmLabel}
                        </Button>
                    </div>
                </div>
            </div>
        </div>,
        document.body
    );
};

export default ConfirmModal;
